export default __webpack_public_path__ + "static/media/powered_by_stripe.0f751748.svg";